import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { FilterModule } from '@wilson/filter';
import { User, UserQualificationV2WithRelation } from '@wilson/interfaces';
import { PipesModule } from '@wilson/pipes';
import { ToQualificationCategoryPipe } from '@wilson/qualification-categories';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DateFnsModule } from 'ngx-date-fns';
import { SharedUserQualificationDetailViewResponse } from '../../../gateways/shared-user-qualifications-v2.gateway';
import { UserQualificationV2DetailsAttachmentSectionComponent } from './components/user-qualification-v2-details-attachment-section/user-qualification-v2-details-attachment-section.component';
import { UserQualificationV2DetailsGeneralSectionComponent } from './components/user-qualification-v2-details-general-section/user-qualification-v2-details-general-section.component';
import { UserQualificationV2DetailsHistorySectionComponent } from './components/user-qualification-v2-details-history-section/user-qualification-v2-details-history-section.component';
import { RouteKnowledgeViaPointsComponent } from './route-knowledge-via-points/route-knowledge-via-points.component';

@Component({
  selector: 'wilson-qualification-details-drawer',
  templateUrl: './qualification-details-drawer.component.html',
  styleUrls: ['./qualification-details-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AuthorizationModule,
    DateFnsModule,
    FeatureFlagsModule,
    FilterModule,
    FontAwesomeModule,
    NzButtonModule,
    NzCollapseModule,
    NzDividerModule,
    NzDrawerModule,
    NzSpinModule,
    PipesModule,
    TranslatePipe,
    UserQualificationV2DetailsAttachmentSectionComponent,
    UserQualificationV2DetailsGeneralSectionComponent,
    UserQualificationV2DetailsHistorySectionComponent,
    RouteKnowledgeViaPointsComponent,
  ],
  providers: [ToQualificationCategoryPipe],
})
export class QualificationDetailsDrawerComponent {
  @Input() isDrawerVisible = false;
  @Input() employee!: Pick<User, 'firstName' | 'lastName'> | null;
  private _qualificationDetails!:
    | UserQualificationV2WithRelation
    | SharedUserQualificationDetailViewResponse
    | null;
  @Input() set qualificationDetails(
    newDetails:
      | UserQualificationV2WithRelation
      | SharedUserQualificationDetailViewResponse
      | null,
  ) {
    this._qualificationDetails = newDetails;
    this.updateRouteData();
  }
  get qualificationDetails():
    | UserQualificationV2WithRelation
    | SharedUserQualificationDetailViewResponse
    | null {
    return this._qualificationDetails;
  }
  @Input() canReadUserQualificationV2Attachments = false;
  @Output() closeDrawer = new EventEmitter<void>();

  public routeId!: string | null;
  public sharedRouteData!: SharedUserQualificationDetailViewResponse['qualification']['route'];

  triggerCloseDrawerEvent(): void {
    this.closeDrawer.emit();
  }

  private updateRouteData(): void {
    this.routeId =
      this.qualificationDetails?.qualification &&
      'routeId' in this.qualificationDetails.qualification
        ? this.qualificationDetails.qualification.routeId
        : '';
    this.sharedRouteData =
      this.qualificationDetails?.qualification &&
      'route' in this.qualificationDetails.qualification
        ? this.qualificationDetails.qualification.route
        : null;
  }
}
